<template >	
	<v-dialog slot="activator" v-model="dialog" persistent max-width="800">
        <v-btn slot="activator" icon>
        	<v-icon :color="dark ? 'white' : 'grey darken-2'">edit</v-icon>
        </v-btn>
        
        <v-card >
        	<v-toolbar><v-toolbar-title>
        		EDIT DEPARTMENTS
        	</v-toolbar-title></v-toolbar>
         	<v-card-title class="body-2" color="black">
         		<v-layout column class="pl-1 pt-2 ml-1 title">
	         		<v-flex>
	         			<v-layout row>
	         				<v-flex xs2>{{!room && multiSelectRoomArray.length > 0 ? 'Rooms:' : 'Room:'}}</v-flex>
	         				<v-flex v-if="room">{{room.bldgAlpha}} - {{room.number}}</v-flex>
	         				<v-flex v-if="!room && multiSelectRoomArray.length > 0"> 
	         					{{ this.prettifiedRoomKeyArray.toString() }}
	         				</v-flex>
         				</v-layout>
         			</v-flex>
         		</v-layout>
         	</v-card-title> 
        	<v-card-text class="pb-5">
		        <v-flex > <!--- HEADERS -->
					<v-layout row class="body-2 ml-4 mt-4 mb-2 title">						
						<v-flex xs9 class="pb-1 pl-2 ">Department</v-flex>
						<v-flex xs2 class="pb-1 pl-2 mr-2">PCT</v-flex>
						<v-flex xs1 class="pb-1 px-2"></v-flex>							
					</v-layout>
					<v-divider></v-divider>
					<v-list class="programList ml-1 mt-3"  >

						<v-list-tile v-for="(item, index) in newDepts" 
							:key="index"
							class="">
							
							<v-layout row>
								<v-flex xs9 class="mr-4">
									<!-- :readonly="item.key ? true : false"	 -->					
								  	<v-autocomplete
										:items="depts"
										item-text="deptNameAndID"
										item-value="deptID"
										v-model="item.deptID"
										cache-items
										class=""
										flat
										light
										hide-no-data
										hide-details
										label="Enter Department Name"
										solo										
									>
										<template slot="item" slot-scope="{ item, tile }">
									        <v-list-tile-avatar dark tile color="grey darken-3" class="smallerAvatar" style="color: white;">
									        	{{item.deptID}}
									        </v-list-tile-avatar>
									        <v-list-tile-content>
										        <v-list-tile-title>
										          	{{item.deptName}}
										        </v-list-tile-title>
										        <v-list-tile-sub-title v-text="`${item.collegeID} ${item.collegeName}`"></v-list-tile-sub-title>
									        </v-list-tile-content>
									    </template>
									    <template slot="selection" slot-scope="{ item, tile }">
									        <v-list-tile-content>
										        <v-list-tile-title>
										          	{{item.deptName}} ({{item.deptID}})
										        </v-list-tile-title>
										        <v-list-tile-sub-title v-text="`${item.collegeID} ${item.collegeName}`"></v-list-tile-sub-title>
									        </v-list-tile-content>
									    </template>
									</v-autocomplete>
								</v-flex>

								<v-flex xs2 class="">						
								  	<v-text-field 
								  		class="body-1 "                         
				                        v-model="item.percentage"
				                        label="Percentage"
				                        single-line 
				                        flat solo   
				                        hide-details                    
				                        @change="changed=true">                   
				                    </v-text-field>
								</v-flex>

								<v-flex xs1 class="px-2 text-xs-right" >
									<v-tooltip top>		              				<v-btn icon slot="activator">                
						                <v-icon small  @click="deleteDept(index)" color="red lighten-2">close</v-icon>          
						            </v-btn>
							            <span>Delete</span>
						            </v-tooltip>
								</v-flex>

							</v-layout>
						</v-list-tile>
					</v-list>

					<v-flex class="ml-2">
						<v-btn icon @click="deptAddLine" ><v-icon color="grey darken-2">add</v-icon></v-btn>
					</v-flex>
				
				</v-flex>
			</v-card-text>
        	<v-card-actions>

	          	<v-spacer></v-spacer>
	          	<v-btn color="green darken-1" flat @click.native="cancel">Cancel</v-btn>
	          	<v-btn color="green darken-1" class="mr-4" flat @click.native="saveDepts">Apply</v-btn>
	        </v-card-actions>
    	</v-card>
    </v-dialog>
    
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

export default {
	data: () => ({
		employee: 	null,
		checkbox: 	false,
		loading: 	false,
		items: 		[],
		search: 	null,
		select: 	null,
		dialog: 	false,
		newDepts: 	[],
		newDept:    {	percentage: null, 
						deptID: null, 
					},
	}),

	props: [ "room", "dark",  ],

	watch: {
		// When dialog opens, set newDepts to a copy of the existing rooms depts
		// If there are no programs, add a blank line to the control
		dialog(val) {
			// Clear First
			this.newDepts = []

			// If no room, assume multiple
			if (!this.room) { this.deptAddLine() }

			if (val==true && this.room) {
				this.newDepts = [...this.room.PCT]
				
				if (this.newDepts.length == 0) {
					this.deptAddLine()
				}
			}

		}
	},

	computed: {
		...mapState(	{ 	depts: 	state => state.lists.depts,
							multiSelectRoomArray: state => state.ui.multiSelectRoomArray,		}),
		
		roomKeyArray: function () {
			return this.multiSelectRoomArray.map((room) => room.roomKey)
		},

		prettifiedRoomKeyArray: function () {
			return this.multiSelectRoomArray.map((room) => { return " " + room.bldgAlpha + "-" + room.number })
		}
	},

	methods: {
		...mapMutations([	'setSnackText',	]),
		...mapActions(	[ 	'updateDepts',	]),

		deptAddLine: function () {
	    	this.newDepts.push({...this.newDept})
	    },

	    deleteDept: function (index) {
	    	console.log("Delete", index)
	    	console.log(this.newDepts)
	    	this.$delete(this.newDepts, index)
	    	console.log(this.newDepts)
	    },

	    cancel: function () {
	    	this.refresh()
	    },

	    refresh: function () {
	    	this.dialog=false
	    	this.$emit('refresh', true)
	    },

		saveDepts: function() {

			// Clear any of the blank lines
			const payloadDepts = this.newDepts.filter((dept) => dept.deptID)

			// Local validation on 100 percent total
			let totalPercentage = 0
			this.newDepts.forEach((dept) => totalPercentage += parseInt(dept.percentage))
			if (totalPercentage!=100) { this.setSnackText("Percentages not equal to 100"); return }
	    	
	    	const payload = { 	'roomKeyArray' :  !this.room && this.multiSelectRoomArray.length > 0 ? 
	    								this.multiSelectRoomArray.map((room) => { return room.roomKey }) : [this.room.roomKey] ,  
	    						'departments': payloadDepts
	    				  	}
	    	
			this.updateDepts(payload).then((response) => {
	    		this.setSnackText(response)
    			this.refresh()
	    	})
	    },
	}
}
</script>

<style>
.smallerAvatar .v-avatar--tile {
	font-size: 10pt !important;
}
</style>




// WEBPACK FOOTER //
// src/components/forms/EditDepartmentsDialog.vue